module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"login":"Anmelden","or":"oder","signup":"Registrieren","toComment":"um selbst zu kommentieren."},"en":{"login":"Login","or":"or","signup":"Sign up","toComment":"to comment."}}')
  delete Component.options._Ctor
}
